import { isEmpty } from 'lodash';
import { useEffect, useState } from 'react';

export const useTransactionPagination = (
  transactions,
  pageNumber,
  pageSize = 20,
) => {
  const [transactionList, setTransactionList] = useState([]);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    if (!isEmpty(transactions)) {
      if (pageNumber === 1) {
        setTransactionList([...transactions]);
      } else {
        setTransactionList((items) => [...items, ...transactions]);
      }
    } else if (pageNumber === 1) {
      // An empty page-1 response means there's genuinely nothing to show (a
      // fresh account/filter) — page 2+ coming back empty just means Load
      // More ran out, so the pages already accumulated stay put.
      setTransactionList([]);
    }

    // 80431: transactionsTotalCount from the API has been unreliable, so a
    // page shorter than pageSize (including empty) is treated as the real
    // end instead — the server's own signal that there's nothing left,
    // regardless of what the total count says.
    setHasMore(!isEmpty(transactions) && transactions.length >= pageSize);

    // pageNumber intentionally left out of the deps: it's bumped a render
    // before the matching fetch resolves, and re-running this against the
    // previous page's still-unchanged `transactions` would re-append it.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transactions, pageSize]);

  return [transactionList, hasMore];
};
